/*
    JourneyMaker Home

    The home page for journey maker. Show info, and let them start their journey

    - Top bar that shows progress across entire journey making
    - Button that lets them select their theme and get started

    When navgating here, may want to reset state
 */


import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { toggleSelectJourneyModal } from '../../actions/util-actions'
import { setJourneyNavStep } from '../../actions/journey-actions'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';

import '../../css/JourneyHome.css'

export const gotoJourney = (props, showAdult) => {
   props.setJourneyNavStep(props.galleryId, 1)
   props.toggleSelectJourneyModal(props.galleryId, showAdult)
}

const Home = props => (
   <span>
      <div className={'theme-filter-container'}>
         <Hammer onTap={() => gotoJourney(props, false)} options={tapOptions} >
            <div className={'theme-filter'} >
            </div>
         </Hammer>
         <Hammer onTap={() => gotoJourney(props, true)} options={tapOptions} >
            <div className={'theme-filter'}>
            </div>
         </Hammer>
      </div>
   </span>
)

//{() => props.setJourneyNavStep(props.galleryId, 1)}
const mapStateToProps = (state, ownProps) => ({...ownProps})
const mapDispatchToProps = dispatch => bindActionCreators({
  toggleSelectJourneyModal,
  setJourneyNavStep
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)


// WEBPACK FOOTER //
// ./src/components/JourneyHome/JourneyHome.js